import type { InteractionBlockReason, InteractionBlockSnapshot } from "./InteractionBlockTypes";

export class InteractionBlockStore {
  private readonly reasons = new Set<InteractionBlockReason>();
  private readonly listeners = new Set<(snapshot: InteractionBlockSnapshot) => void>();

  public getSnapshot(): InteractionBlockSnapshot {
    return { reasons: Array.from(this.reasons) };
  }

  public isBlocked(): boolean {
    return this.reasons.size > 0;
  }

  public hasReason(reason: InteractionBlockReason): boolean {
    return this.reasons.has(reason);
  }

  public add(reason: InteractionBlockReason): void {
    const before = this.reasons.size;
    this.reasons.add(reason);
    if (this.reasons.size !== before) {
      this.emit();
    }
  }

  public remove(reason: InteractionBlockReason): void {
    const removed = this.reasons.delete(reason);
    if (removed) {
      this.emit();
    }
  }

  public subscribe(listener: (snapshot: InteractionBlockSnapshot) => void): () => void {
    this.listeners.add(listener);
    listener(this.getSnapshot());
    return () => this.listeners.delete(listener);
  }

  private emit(): void {
    const snapshot = this.getSnapshot();
    for (const listener of this.listeners) {
      listener(snapshot);
    }
  }
}